exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container-overflow a.active{display:block!important;padding:13px 10px;background:#fff;box-shadow:0 1px 4px 0 rgba(0,0,0,.15);border:1px solid #d1d1d1;position:absolute!important;left:-3px;top:-40px;color:#545454;font-weight:600;font-size:14px}.container-overflow a.active:before{content:\"\";position:absolute;display:block;left:67px;bottom:-7px;width:15px;height:15px;background:#fff;transform:rotate(45deg);box-shadow:0 1px 4px 0 rgba(0,0,0,.15);border-left:none}.container-overflow a.active:after{content:\"\";position:absolute;display:block;left:50px;bottom:0;width:40px;height:10px;background:#fff}.application .app-display .right-side li .container-overflow .text-container a{position:static;font-weight:600;color:#4db699;text-decoration:none;display:table-cell;height:40px;vertical-align:middle;line-height:1.3;margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./directives/overflow/overflow.scss
// module id = 550
// module chunks = 0